import React from 'react';

const SvgPasswordHidden = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.427 8.735a27.984 27.984 0 012.447 2.86.845.845 0 010 .887c-4.742 6.228-9.313 7.993-14.02 5.295l3.572-2.79c.226.05.462.077.705.077 1.712 0 3.14-1.329 3.14-3.007 0-.024 0-.049-.002-.073l4.158-3.249zM16.2 6.181l-3.7 2.89a3.285 3.285 0 00-.368-.02c-1.605 0-2.897 1.166-3.053 2.694l-4.467 3.49a28.801 28.801 0 01-2.423-2.753c-.25-.266-.25-.62 0-.975C7.013 5.328 11.583 3.542 16.2 6.18z"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(-38 11.918 11.979)",
  x: -0.082,
  y: 11.229,
  width: 24,
  height: 1.5,
  rx: 0.75
})));

export default SvgPasswordHidden;